'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./reach-utils-use-force-update.cjs.prod.js");
} else {
  module.exports = require("./reach-utils-use-force-update.cjs.dev.js");
}
